import { render, staticRenderFns } from "./View4.vue?vue&type=template&id=c8d38ba0&scoped=true&"
import script from "./View4.vue?vue&type=script&lang=js&"
export * from "./View4.vue?vue&type=script&lang=js&"
import style0 from "./View4.vue?vue&type=style&index=0&id=c8d38ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d38ba0",
  null
  
)

export default component.exports